import styled, { css } from 'styled-components';

import UI from '#front-credpago';

import globals from '../../globals';

export const Container = styled.div`
  width: 100%;
  max-width: calc(${globals.containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  width: 80%;
  margin: 100px 0px;
  padding: 20px;

  .content-textarea {
    width: 80%;
  }

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    width: 100%;
    margin: 25px 0px 50px 0px;

    .content-textarea {
      width: 100%;
    }
  }
`;

export const WrapperQuestion = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Question = styled.p`
  font-size: 24px;
  color: ${globals.colors.darkBlue};
  font-family: ${globals.fonts.default};
  font-weight: 600;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    text-align: center;
  }
`;

export const WrapperNote = styled.div`
  display: flex;
  cursor: pointer;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-top: 30px;
    justify-content: space-between;
  }
`;

export const WrapperRadios = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  text-align: center;

  .ant-radio-wrapper {
    padding: 5px 0px;
  }

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const WrapperInput = styled.div`
  width: 700px;
  margin-top: 30px;
  text-align: center;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const WrapperTextArea = styled.div`
  width: 100%;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-bottom: 20px;
  }
`;

export const WrapperBtn = styled.div`
  width: 140px;
`;

export const WrapperConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const WrapperMessage = styled.div`
  background: ${globals.colors.green};
  padding: 16px;
  border-radius: 13px;
  display: inline-flex;
  justify-content: center;
  margin-top: 20px;
`;

export const Message = styled.p`
  font-size: 15px;
  color: #fff;
  font-family: ${globals.fonts.default};
  margin: 0px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    text-align: center;
  }
`;

export const AlertWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;
`;

const wrapperImgModifiers = {
  selected: () => css`
    circle:not(.st1) {
      fill: #b1b1b1;
    }
  `,
};

export const WrapperImg = styled.div`
  ${({ selected }) => css`
    width: 50px;
    height: 50px;

    ${!selected && wrapperImgModifiers.selected()}
  `}
`;

export const Error = styled.span`
  color: ${globals.colors.danger};
  font-family: ${globals.fonts.default};
  font-size: 16px;
  font-weight: bold;
`;

export const CustomDescription = styled(UI.Description)`
  text-align: center;
`;
